import { render } from "./ContinuePlayComponent.vue?vue&type=template&id=23ba03c4&scoped=true&ts=true"
import script from "./ContinuePlayComponent.vue?vue&type=script&lang=ts"
export * from "./ContinuePlayComponent.vue?vue&type=script&lang=ts"

import "./ContinuePlayComponent.vue?vue&type=style&index=0&id=23ba03c4&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ba03c4"]])

export default __exports__